import { render, staticRenderFns } from "./UserProfileAddHandle.vue?vue&type=template&id=1e4400f4&"
import script from "./UserProfileAddHandle.vue?vue&type=script&lang=js&"
export * from "./UserProfileAddHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports